import { render, staticRenderFns } from "./MailAnalysis.vue?vue&type=template&id=b8fc56e2&scoped=true&"
import script from "./MailAnalysis.vue?vue&type=script&lang=js&"
export * from "./MailAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./MailAnalysis.vue?vue&type=style&index=0&id=b8fc56e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fc56e2",
  null
  
)

export default component.exports